import React, { PureComponent } from "react";
import {
  Metric,
  selectFormat,
  // Error
} from "components/Utils/Utils.js";
import { matches } from "lodash";

class OfficialRatings extends PureComponent {
  render() {
    // const { loading, data } = this.props;

    // if (data.data.hasData === false) {
    //   return <Error minHeight={260} />;
    // }

    const SAMPLE_DATA = {
      meta: {
        date: "2022-07-17T00:00:00Z",
        match_day: 3,
        games_played: 4,
      },

      matches: [
        {
          meta: {
            team1: "DE",
            team2: "CA",
            air_time: "5am",
            match: "10",
            stage: "Group",
          },
          results: [
            [
              {
                current: "1",
                previous: "2",
                estimate: "90",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 222,
                },
                metric_estimate: {
                  value: 333,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "2",
                previous: "87",
                estimate: "20",
                metric_current: {
                  value: 444,
                },
                metric_previous: {
                  value: 555,
                },
                metric_estimate: {
                  value: 666,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "3",
                previous: "20",
                estimate: "30",
                metric_current: {
                  value: 777,
                },
                metric_previous: {
                  value: 888,
                },
                metric_estimate: {
                  value: 999,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
            ],
            [
              {
                current: "60",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 12,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "70",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 555,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "80",
                previous: "20",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
            ],
            [
              {
                current: "90",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "100",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "100",
                previous: "20",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
            ],
          ],
        },
        {
          meta: {
            team1: "Mexico",
            team2: "Poland",
            air_time: "5am",
            match: "12",
            stage: "Group",
          },

          results: [
            [
              {
                current: "1",
                previous: "2",
                estimate: "90",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 222,
                },
                metric_estimate: {
                  value: 333,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "2",
                previous: "87",
                estimate: "20",
                metric_current: {
                  value: 444,
                },
                metric_previous: {
                  value: 555,
                },
                metric_estimate: {
                  value: 666,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "3",
                previous: "20",
                estimate: "30",
                metric_current: {
                  value: 777,
                },
                metric_previous: {
                  value: 888,
                },
                metric_estimate: {
                  value: 999,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
            ],
            [
              {
                current: "60",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 12,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "70",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 555,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "80",
                previous: "20",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
            ],
            [
              {
                current: "90",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
              {
                current: "100",
                previous: "87",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
              },
              {
                current: "100",
                previous: "20",
                estimate: "23",
                metric_current: {
                  value: 111,
                },
                metric_previous: {
                  value: 111,
                },
                metric_estimate: {
                  value: 111,
                },
                pre_game: 20,
                first_half_game: 30,
                second_half_game: 40,
                pre_game_metric: {
                  value: 1232,
                },
                first_half_metric: {
                  value: 1232,
                },
                second_half_metric: {
                  value: 1232,
                },
              },
            ],
          ],
        },
      ],
    };

    const COLORS = ["orange", "teal", "yellow"];

    const renderColumns = (data) =>
      data.map((result, index) => (
        <div className="mt-3 mb-3 col-3" key={index}>
          <div className="mx-2 d-flex">
            <div className="info-detail cell-chart-label d-flex justify-content-center align-items-center"></div>

            <div className="mx-2 progress progress-bar-lg cell-chart">
              <div
                className={`progress-bar progress-bar-${COLORS[index]}`}
                role="progressbar"
                style={{ width: result[index].current + "%" }}
                aria-valuenow="10"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>

            <div className="d-flex justify-content-center align-items-center">
              <Metric {...result[index].metric_current} size={"xs"} />
            </div>
          </div>

          <div className="mx-2">
            <div className="d-flex">
              <div className="info-detail cell-chart-label d-flex justify-content-center align-items-center">
                vs.2008
              </div>

              <div className="mx-2 progress progress-bar-lg cell-chart">
                <div
                  className={`progress-bar progress-bar-striped progress-bar-${COLORS[index]}-light`}
                  role="progressbar"
                  style={{ width: result[index].previous + "%" }}
                  aria-valuenow="10"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <Metric {...result[index].metric_previous} size={"xs"} />
              </div>
            </div>
          </div>

          <div className="mx-2">
            <div className="d-flex">
              <div className="info-detail cell-chart-label d-flex justify-content-center align-items-center">
                vs. Estimate
              </div>

              <div className="mx-2 progress progress-bar-lg cell-chart">
                <div
                  className={`progress-bar progress-bar-striped progress-bar-striped-reverse progress-bar-${COLORS[index]}-lighter`}
                  role="progressbar"
                  style={{ width: result[index].estimate + "%" }}
                  aria-valuenow="10"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>

              <div className="d-flex justify-content-center align-items-center">
                <Metric {...result[index].metric_estimate} size={"xs"} />
              </div>
            </div>

            <div className="mt-5 progress progress-bar-sm">
              <div
                className="mr-1 progress-bar-gray-light progress-bar-striped"
                role="progressbar"
                style={{ width: result[index].pre_game + "%" }}
                aria-valuenow="30"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                className={`mr-1 progress-bar progress-bar-${COLORS[index]} progress-bar-striped`}
                role="progressbar"
                style={{ width: result[index].first_half_game + "%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                className={`mr-1 progress-bar progress-bar-${COLORS[index]} progress-bar-striped`}
                role="progressbar"
                style={{ width: result[index].second_half_game + "%" }}
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>

            <div className="d-flex">
              <div className="mr-1 info-detail"></div>
              <div
                className="mt-1 mr-1 info-detail"
                style={{ width: result[index].pre_game + "%" }}
              >
                Pre-Game
                <div className="mt-1">
                  <Metric {...result[index].pre_game_metric} size={"xs"} />
                </div>
              </div>

              <div
                className="mt-1 mr-1 info-detail"
                style={{ width: result[index].first_half_game + "%" }}
              >
                1<sup>st</sup> Half
                <div className="mt-1">
                  <Metric {...result[index].first_half_metric} size={"xs"} />
                </div>
              </div>

              <div
                className="mt-1 mr-1 info-detail"
                style={{ width: result[index].second_half_game + "%" }}
              >
                2<sup>nd</sup> Half
                <div className="mt-1">
                  <Metric {...result[index].second_half_metric} size={"xs"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ));

    const renderRows = () =>
      SAMPLE_DATA.matches.map((match, i) => (
        <div className="col-12" key={i}>
          <div className="row">
            <div className="col-3 mt-4 mb-4">
              <div className="info-heading mb-1">
                🇧🇪 {match.meta.team1} vs 🇨🇦 {match.meta.team2}
              </div>
              <div className="info-detail mb-1">
                Air Time:{" "}
                <span className="info-value">{match.meta.air_time}</span>
              </div>
              <div>
                <span className="info-detail">
                  Match: <span className="info-value">{match.meta.match}</span>
                </span>
                <span className="info-detail ml-2">
                  Stage: <span className="info-value">{match.meta.stage}</span>
                </span>
              </div>
            </div>

            {renderColumns(match.results)}

            {i === matches.length - 1 && (
              <div className="my-2 divider-dotted-spaced"></div>
            )}
          </div>
        </div>
      ));

    return (
      <div className="row">
        <div className="col-12">
          <small>All values are in Thousands (000)</small>
        </div>
        <div className="col-12">
          <div className="flex">
            <span>
              Date:{" "}
              <span className="column-header">
                {selectFormat("date", SAMPLE_DATA.meta.date, "MM/DD/YY")}
              </span>
              <span className="mx-2">|</span>
            </span>

            <span>
              Match Day:{" "}
              <span className="column-header">
                {SAMPLE_DATA.meta.match_day}
              </span>{" "}
              <span className="mx-2">|</span>
            </span>

            <span>
              Games Played:{" "}
              <span className="column-header">
                {SAMPLE_DATA.meta.games_played}
              </span>
            </span>
          </div>
        </div>

        <div className="mt-4 col-12">
          <div className="row row-divider-line-bottom">
            <div className="col-3">
              <div className="column-header text-left">Match</div>
            </div>
            <div className="col-3">
              <div className="column-header">Tad</div>
            </div>
            <div className="col-3">
              <div className="column-header">Official Ratings</div>
            </div>
            <div className="col-3">
              <div className="column-header">Fox Official</div>
            </div>
          </div>
        </div>

        {renderRows()}
      </div>
    );
  }
}

export default OfficialRatings;
